<div fxLayout="column" fxLayout.gt-md="row">
  <div fxFlex class="mat-elevation-z2">

    <app-crawler-status-table [supplierRows]="productPages" (downloadSpreadsheet)="downloadSpreadsheet($event)"></app-crawler-status-table>

  </div>

</div>
